function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useClassPrepend } from "../../../hook/ui/common/className/useClassPrepend";
import "./unstyledUncontrolledCheckbox.css";

/*
    Returns an uncontrolled checkbox

    props
        (object)    checkboxIndicator   An object of the icons to use for the checkbox
                                            - Example = {
                                                checked: <img src={checkSquareIcon}>,
                                                unchecked: <img src={emptySquareIcon}>
                                            }
        (boolean)   defaultChecked      (part of the ...rest props) When true, the checkbox is checked by default. 
                                            - Do not use defaultChecked with the controlled component                                            
        (boolean)   error               When true, an error classname is added to allow special error styling (like red text)
        (jsx)       helperText          A message to show below the checkbox
        (children)  children            The content/label of the checkbox        
*/

const UnstyledUncontrolledCheckbox = ({
  classPrepend = "unstyled",
  className = "",
  checkboxIndicator = {
    checked: "✓",
    unchecked: ""
  },
  disabled = false,
  error = false,
  helperText = "",
  children,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  return /*#__PURE__*/React.createElement("div", getClassNameWithGlobal(`checkbox-container ${error ? "checkbox-container-error" : ""}`, className), /*#__PURE__*/React.createElement("label", getClassNameWithGlobal("checkbox-inner-container"), /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox"
  }, getClassNameWithGlobal("checkbox-input"), {
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("checkbox-indicator-container"), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("checkbox-indicator-checked"), checkboxIndicator.checked), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("checkbox-indicator-unchecked"), checkboxIndicator.unchecked)), /*#__PURE__*/React.createElement("span", null, children)), helperText && /*#__PURE__*/React.createElement("p", getClassName("checkbox-helper-text"), helperText));
};
export { UnstyledUncontrolledCheckbox };